'use strict';

var React = require('react');
var styletronEngineAtomic = require('styletron-engine-atomic');
var styletronReact = require('styletron-react');
var baseui = require('baseui');
var Theme = require('./Theme.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var engine = new styletronEngineAtomic.Client();
var createdTheme = Theme.createTheme({});
function Provider(_ref) {
  var children = _ref.children,
      value = _ref.value,
      debug = _ref.debug,
      theme = _ref.theme;
  return /*#__PURE__*/React__default["default"].createElement(styletronReact.Provider, {
    value: value || engine,
    debug: debug
  }, /*#__PURE__*/React__default["default"].createElement(baseui.BaseProvider, {
    theme: theme || createdTheme
  }, children));
}

module.exports = Provider;
